import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailTemplatesRoutingModule } from './email-templates-routing.module';
import { CrudComponent } from './crud/crud.component';
import { ListComponent } from './list/list.component';
import { FormsModule } from '@angular/forms';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { LogsComponent } from './logs/logs.component';


@NgModule({
  declarations: [
    CrudComponent,
    ListComponent,
    LogsComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    EmailTemplatesRoutingModule,
    NzSpinModule,
    NzInputModule,
    NzSwitchModule,
    NzSelectModule,
    NzButtonModule,
    NzIconModule,
    NzDividerModule,
    NzTableModule,
    NzTagModule,
    NzGridModule,
    NzDropDownModule,
    NzCheckboxModule
  ]
})
export class EmailTemplatesModule { }
